module.exports = __webpack_public_path__ + "static/fonts/luengo-bold-webfont.3bd5e465.woff2";